import {
  getFontCss,
  Popup,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import { useTranslate } from 'src/localization/Trns'
import { createSetIsDeleteExpenseReportsPopupOpen } from 'src/redux/actions/app.actions'
import { deleteExpenseReports } from 'src/redux/actions/data/expenses.actions'
import {
  selectDeleteExpenseReportsTopLevelError,
  selectDeletingExpenseReports,
  selectSelectedDeleteExpenseReportsFromState,
} from 'src/redux/selectors/data/expenses.selectors'
import { css } from 'styled-components'

const DeleteExpenseReportsPopup: React.FC = (): React.ReactElement => {
  const translate = useTranslate()

  const dispatch = useDispatch()
  const expenseReports = useSelector(
    selectSelectedDeleteExpenseReportsFromState,
  )
  const deletingExpenseReports = useSelector(selectDeletingExpenseReports)
  const deletingExpenseReportsTopLevelError = useSelector(
    selectDeleteExpenseReportsTopLevelError,
  )
  const { analytics } = useAnalyticsContext()

  const subTitleTopText =
    expenseReports !== undefined &&
    (expenseReports.length === 1
      ? translate('You are about to delete 1 report.')
      : translate('You are about to delete ${count} reports.', {
          count: expenseReports.length.toString(),
        }))

  const dispatchDeleteExpenseReports = (): void => {
    expenseReports !== undefined &&
      dispatch(deleteExpenseReports(expenseReports, analytics))
  }

  const closePopup = (): void => {
    dispatch(createSetIsDeleteExpenseReportsPopupOpen(false))
  }

  return (
    <Popup
      onClickClose={closePopup}
      showCloseButton
      css={`
        display: flex;
        flex-direction: column;
        position: relative;
      `}
    >
      <ConfirmationPopupContent
        title={
          expenseReports?.length === 1
            ? translate('Delete Report')
            : translate('Delete Reports')
        }
        subtitle={
          <>
            <p
              css={css`
                margin-bottom: 20px;
              `}
            >
              {subTitleTopText}
            </p>
            <p
              css={css`
                ${getFontCss(
                  16,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              {translate('This action cannot be undone.')}
            </p>
          </>
        }
        actionButtonLabel={translate('Confirm and Delete')}
        actionButtonOnClick={dispatchDeleteExpenseReports}
        actionButtonLoading={deletingExpenseReports}
        actionButtonVariant="severe"
        topLevelError={deletingExpenseReportsTopLevelError}
        isCancelButtonLink
        underline={false}
        cancelButtonOnClick={closePopup}
        cancelButtonLabel={translate('Cancel')}
      />
    </Popup>
  )
}

export default DeleteExpenseReportsPopup
